module.exports = __webpack_public_path__ + "img/sister.be5030ca.webp";